import { Card } from '@/components/ui/card';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-stone-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="p-8 md:p-12">
          <h1 className="text-4xl font-bold text-stone-900 mb-6">Terms of Service</h1>
          <p className="text-sm text-stone-500 mb-8">Last Updated: January 2025</p>

          <div className="prose prose-stone max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-stone-700 leading-relaxed">
                By accessing and using Garden & Greenhouse ("the Site"), you accept and agree to be bound by the terms 
                and provision of this agreement. If you do not agree to these terms, please do not use this Site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">2. Description of Service</h2>
              <p className="text-stone-700 leading-relaxed">
                Garden & Greenhouse provides gardening information, articles, product recommendations, affiliate links, 
                AI-powered gardening assistance, and a directory of gardening-related businesses and products. Our services 
                include but are not limited to:
              </p>
              <ul className="list-disc list-inside text-stone-700 space-y-2 mt-4">
                <li>Gardening articles and guides (both original and AI-generated content)</li>
                <li>Product reviews and recommendations</li>
                <li>Affiliate links to third-party merchants</li>
                <li>AI-powered plant care assistant</li>
                <li>Business directory (Garden Hub)</li>
                <li>Newsletter subscriptions</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">3. AI-Generated Content</h2>
              <p className="text-stone-700 leading-relaxed">
                Some content on this Site is generated using artificial intelligence technology. While we strive for accuracy, 
                AI-generated content may contain errors or inaccuracies. Users should:
              </p>
              <ul className="list-disc list-inside text-stone-700 space-y-2 mt-4">
                <li>Verify information with multiple sources</li>
                <li>Consult with professional horticulturists for specific advice</li>
                <li>Use AI-generated recommendations as general guidance only</li>
                <li>Understand that AI content is not a substitute for professional expertise</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">4. Affiliate Relationships</h2>
              <p className="text-stone-700 leading-relaxed">
                Garden & Greenhouse participates in affiliate marketing programs. We may earn commissions from purchases 
                made through links on our Site. This does not affect the price you pay. Please see our Affiliate Disclosure 
                page for complete information.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">5. User Conduct</h2>
              <p className="text-stone-700 leading-relaxed mb-4">You agree not to:</p>
              <ul className="list-disc list-inside text-stone-700 space-y-2">
                <li>Use the Site for any unlawful purpose</li>
                <li>Attempt to gain unauthorized access to any portion of the Site</li>
                <li>Submit false or misleading information</li>
                <li>Interfere with or disrupt the Site or servers</li>
                <li>Copy, reproduce, or distribute Site content without permission</li>
                <li>Use automated systems to access the Site without consent</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">6. Third-Party Links and Services</h2>
              <p className="text-stone-700 leading-relaxed">
                Our Site contains links to third-party websites and services. We are not responsible for the content, 
                privacy policies, or practices of third-party sites. Clicking on third-party links is at your own risk. 
                We recommend reviewing the terms and privacy policies of any third-party sites you visit.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">7. Disclaimer of Warranties</h2>
              <p className="text-stone-700 leading-relaxed">
                THE SITE AND ALL CONTENT ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED, 
                INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, 
                OR NON-INFRINGEMENT. We do not warrant that:
              </p>
              <ul className="list-disc list-inside text-stone-700 space-y-2 mt-4">
                <li>The Site will be uninterrupted or error-free</li>
                <li>Defects will be corrected</li>
                <li>The Site is free of viruses or harmful components</li>
                <li>Information on the Site is accurate, complete, or current</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">8. Limitation of Liability</h2>
              <p className="text-stone-700 leading-relaxed">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, GARDEN & GREENHOUSE SHALL NOT BE LIABLE FOR ANY INDIRECT, 
                INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER 
                INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">9. Intellectual Property</h2>
              <p className="text-stone-700 leading-relaxed">
                All content on this Site, including text, graphics, logos, images, and software, is the property of 
                Garden & Greenhouse or its content suppliers and is protected by international copyright laws. 
                Unauthorized reproduction or distribution is prohibited.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">10. Business Listings</h2>
              <p className="text-stone-700 leading-relaxed">
                Businesses listed in our Garden Hub directory are subject to approval. We reserve the right to accept, 
                reject, or remove any business listing at our sole discretion. Listing fees, if applicable, are 
                non-refundable. We do not guarantee sales or leads from listings.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">11. Privacy and Data Collection</h2>
              <p className="text-stone-700 leading-relaxed">
                Your use of the Site is also governed by our Privacy Policy. By using the Site, you consent to the 
                collection and use of your information as described in the Privacy Policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">12. Modifications to Terms</h2>
              <p className="text-stone-700 leading-relaxed">
                We reserve the right to modify these Terms of Service at any time. Changes will be posted on this page 
                with an updated "Last Updated" date. Your continued use of the Site after changes constitutes acceptance 
                of the modified terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">13. Termination</h2>
              <p className="text-stone-700 leading-relaxed">
                We may terminate or suspend your access to the Site immediately, without prior notice or liability, 
                for any reason, including breach of these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">14. Governing Law</h2>
              <p className="text-stone-700 leading-relaxed">
                These Terms shall be governed by and construed in accordance with the laws of the United States, 
                without regard to its conflict of law provisions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">15. Contact Information</h2>
              <p className="text-stone-700 leading-relaxed">
                If you have any questions about these Terms of Service, please contact us at:
                <br />
                <strong>Email:</strong> contact@gardenandgreenhouse.com
              </p>
            </section>

            <section className="bg-emerald-50 p-6 rounded-lg mt-8">
              <p className="text-sm text-stone-600">
                <strong>Acknowledgment:</strong> By using Garden & Greenhouse, you acknowledge that you have read, 
                understood, and agree to be bound by these Terms of Service.
              </p>
            </section>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;
